import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common/PageHeader";
import { SurfaceCard } from "@/components/common/Cards";
import { Button } from "@/components/ui/button";
import { Check, ShieldCheck, Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Plans() {
  const { user } = useAuth();
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data)).catch(() => {}); }, []);
  const inactive = user && user.subscription_active === false && !user.is_admin;

  return (
    <div>
      <PageHeader title="Plans & Pricing" subtitle="Choose the plan that fits your practice" breadcrumb={["Management", "Plans"]} />

      {inactive && (
        <div className="mb-6 rounded-xl border border-amber-200 dark:border-amber-500/30 bg-amber-50 dark:bg-amber-500/10 p-4" data-testid="plans-inactive-banner">
          <div className="flex items-center gap-2 text-sm font-bold text-amber-800 dark:text-amber-300"><ShieldCheck className="h-4 w-4" />Your subscription is not active yet</div>
          <p className="text-xs text-amber-700 dark:text-amber-400/80 mt-1">Choose a plan below to activate CONTAHA. Online payment is coming soon — for now, contact your administrator to activate your account.</p>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-testid="plans-grid">
        {plans.map((p) => (
          <SurfaceCard key={p.id} className={`p-6 flex flex-col ${p.recommended ? "border-2 border-[#00A85A]" : ""}`} data-testid={`plan-${p.slug}`}>
            {p.recommended && <div className="mb-3 inline-flex w-fit items-center gap-1 rounded-full bg-[#00A85A]/12 px-2.5 py-0.5 text-[10px] font-bold text-[#008F4D] dark:text-[#3FD98A]"><Sparkles className="h-3 w-3" />Most popular</div>}
            <div className="text-sm font-bold text-[#101516] dark:text-white">{p.name}</div>
            <div className="mt-2 flex items-end gap-1"><span className="text-3xl font-extrabold text-[#101516] dark:text-white">${p.price}</span><span className="text-xs text-[#8B9698] mb-1">/{p.interval}</span></div>
            <ul className="mt-4 space-y-2 flex-1">
              {(p.features || []).map((f, i) => <li key={i} className="flex gap-2 text-sm text-[#687173] dark:text-[#8B9698]"><Check className="h-4 w-4 text-[#00A85A] shrink-0 mt-0.5" />{f}</li>)}
            </ul>
            <Button onClick={() => toast.info("Online payment (Razorpay) is coming soon. Contact your administrator to activate.")} data-testid={`plan-choose-${p.slug}`} className={`mt-5 rounded-lg ${p.recommended ? "bg-[#00A85A] hover:bg-[#008F4D] text-white" : ""}`} variant={p.recommended ? "default" : "outline"}>Choose {p.name}</Button>
          </SurfaceCard>
        ))}
      </div>
      <p className="mt-6 text-center text-xs text-[#8B9698]">Payments via Razorpay will be enabled soon. Your data stays safe throughout.</p>
    </div>
  );
}
